import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProductCategoriesControllerFindAll$Params } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as ProductCategoriesActions from './product-categories.actions';
import { CreateProductCategoryData, UpdateProductCategoryData } from './product-categories.actions';
import * as ProductCategoriesSelectors from './product-categories.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductCategoriesFacade {
  private store = inject(Store);

  categories$ = this.store.select(ProductCategoriesSelectors.selectAllProductCategories);
  loading$ = this.store.select(ProductCategoriesSelectors.selectProductCategoriesLoading);
  error$ = this.store.select(ProductCategoriesSelectors.selectProductCategoriesError);
  pagination$ = this.store.select(ProductCategoriesSelectors.selectProductCategoriesPagination);
  params$ = this.store.select(ProductCategoriesSelectors.selectProductCategoriesParams);

  categories = toSignal(this.categories$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });
  pagination = toSignal(this.pagination$);
  params = toSignal(this.params$);

  loadCategories(params?: ProductCategoriesControllerFindAll$Params): void {
    this.store.dispatch(ProductCategoriesActions.loadProductCategories({ params }));
  }

  createCategory(categoryData: CreateProductCategoryData): void {
    this.store.dispatch(ProductCategoriesActions.createProductCategory({ categoryData }));
  }

  updateCategory(id: string, categoryData: UpdateProductCategoryData): void {
    this.store.dispatch(ProductCategoriesActions.updateProductCategory({ id, categoryData }));
  }

  deleteCategory(id: string): void {
    this.store.dispatch(ProductCategoriesActions.deleteProductCategory({ id }));
  }
}
